import {
  Directive,
  ElementRef,
  AfterViewInit,
  OnDestroy,
  HostListener,
} from '@angular/core';

@Directive({
  selector: '[tableScrollSync]',
  standalone: true,
})
export class TableScrollSyncDirective implements AfterViewInit, OnDestroy {
  private resizeObserver?: ResizeObserver;
  private mutationObserver?: MutationObserver;

  constructor(private elementRef: ElementRef<HTMLTableElement>) {}

  ngAfterViewInit(): void {
    const table = this.elementRef.nativeElement;
    const tbody = table.querySelector('tbody');
    if (!tbody) return;

    this.syncHeaderPadding();

    this.resizeObserver = new ResizeObserver(() => this.syncHeaderPadding());
    this.resizeObserver.observe(tbody);

    this.mutationObserver = new MutationObserver(() => {
      requestAnimationFrame(() => this.syncHeaderPadding());
    });
    this.mutationObserver.observe(tbody, { childList: true, subtree: true });
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
    this.mutationObserver?.disconnect();
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.syncHeaderPadding();
  }

  private syncHeaderPadding(): void {
    const table = this.elementRef.nativeElement;
    const thead = table.querySelector('thead');
    const tbody = table.querySelector('tbody');
    if (!thead || !tbody) return;

    const scrollbarWidth = tbody.offsetWidth - tbody.clientWidth;
    thead.style.paddingRight = scrollbarWidth > 0 ? `${scrollbarWidth}px` : '';
  }
}
